import {AxiosPromise, AxiosResponse} from 'axios';
import api from './api';
import apiGraphQL from './apiGraphQL';
import {ShopifySubscription} from '../interfaces';

export function createCustomerPortalSession({
  profileId,
  membershipLevel,
}: {
  profileId: number;
  membershipLevel?: string;
}) {
  return new Promise<{url: string}>((resolve, reject) => {
    try {
      api
        .post(`/create-customer-portal-session`, {
          profileId,
          membershipLevel,
        })
        .then((response: AxiosResponse<{url: string}>) => {
          resolve(response.data);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getShopifySubscription({id}: {id: number}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `query ($id: Int!) {
            shopifySubscription(id: $id) {
              id
              email
              currency
              pauseStartDate
              pauseEndDate
              orderIntervalFrequency
              orderIntervalUnit
              returnOrderName
              returnStatus
              expiringAt
              isMonthly
              status
              plan
              createdAt
              rechargeSubscriptionData {
                intervalFrequency
                intervalUnit
                quantity
                nextChargeScheduledAt
              }
            }
          }`,
          variables: {id},
        })
        .then(
          (
            response: AxiosResponse<{
              data: {shopifySubscription: ShopifySubscription};
            }>,
          ) => {
            resolve(
              response as unknown as AxiosPromise<{
                shopifySubscription: ShopifySubscription;
              }>,
            );
          },
        )
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function pauseShopifySubscription(input: {
  shopifySubscriptionId: number;
  pauseEndDate: Date;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation PauseShopifySubscription($input: PauseShopifySubscriptionInput!) {
            pauseShopifySubscription(input: $input) {
              success,
              error,
            }
          }`,
          variables: {
            input,
          },
        })
        .then(response => {
          if (response.data.errors) {
            alert(
              response.data.errors
                .map((e: {message: string}) => e.message)
                .join('\n'),
            );
          }
          resolve(response.data.data.pauseShopifySubscription);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function removeUpcomingSubscriptionPause(input: {
  shopifySubscriptionId: number;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation RemoveUpcomingSubscriptionPause($input: RemoveUpcomingSubscriptionPauseInput!) {
            removeUpcomingSubscriptionPause(input: $input) {
              success,
              error,
            }
          }`,
          variables: {
            input,
          },
        })
        .then(response => {
          if (response.data.errors) {
            alert(
              response.data.errors
                .map((e: {message: string}) => e.message)
                .join('\n'),
            );
          }
          resolve(response.data.data.removeUpcomingSubscriptionPause);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function resumeShopifySubscription(input: {
  shopifySubscriptionId: number;
  pauseEndDate: Date;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation ResumeShopifySubscription($input: ResumeShopifySubscriptionInput!) {
            resumeShopifySubscription(input: $input) {
              success,
              error,
            }
          }`,
          variables: {
            input,
          },
        })
        .then(response => {
          if (response.data.errors) {
            alert(
              response.data.errors
                .map((e: {message: string}) => e.message)
                .join('\n'),
            );
          }
          resolve(response.data.data.resumeShopifySubscription);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function cancelShopifySubscription(input: {
  shopifySubscriptionId: number;
  reasons: string[];
  additionalNotes?: string;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation CancelShopifySubscription($input: CancelShopifySubscriptionInput!) {
            cancelShopifySubscription(input: $input) {
              success,
              error,
            }
          }`,
          variables: {
            input,
          },
        })
        .then(response => {
          if (response.data.errors) {
            alert(
              response.data.errors
                .map((e: {message: string}) => e.message)
                .join('\n'),
            );
          }
          resolve(response.data.data.cancelShopifySubscription);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
